import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { API_CALL_STATUS } from "../../assets/constants/constants";
import { getLoggedInUser } from "../../redux/auth/authSlice";
import NotAuthorizedPage from "../../pages/not-authorised/NotAuthorisedPage";
import Loader from "../loader/Loader";

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();

  const loggedInUser = useSelector((state) => state.auth.loggedInUser);
  const sessionStatus = useSelector((state) => state.auth.sessionStatus);

  // Fetch session only when user is NOT logged in
  useEffect(() => {
    if (!loggedInUser && sessionStatus === API_CALL_STATUS.IDLE) {
      dispatch(getLoggedInUser());
    }
  }, [dispatch, loggedInUser, sessionStatus]);

  // Condition 1: If user exists -> allow immediately
  if (loggedInUser) {
    return children;
  }

  // Condition 2: If no user, but verifying session -> show loader
  if (!loggedInUser && 
      (sessionStatus === API_CALL_STATUS.LOADING || sessionStatus === API_CALL_STATUS.IDLE)) {
    return <Loader />;
  }

  // Condition 3: If user not logged in and verification failed -> block
  if (!loggedInUser && sessionStatus === API_CALL_STATUS.FAILED) {
    return <NotAuthorizedPage />;
  }

  return children;
};

export default ProtectedRoute;
